import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import LoadingScreen from '../../LoadingScreen/LoadingScreen';
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import * as styles from './styles.css';

function Widget({
  children,
  className,
  controls,
  widgetVisibilityControls,
  footer,
  handleRef,
  isLoading,
  noPadding,
  title,
  nonBlockingLoading,
  preventControls
}) {
  return (
    <div className={
      classNames(
        'panel',
        'panel-default',
        styles.widget,
      )}
    >

      {!nonBlockingLoading && <LoadingScreen isLoading={isLoading} />}
      {title && (
        <header className="panel-heading">
          <span>{typeof title === 'function' ? title() : title}</span>
          <div className="pull-right">
            {nonBlockingLoading && <LoadingIndicator isLoading={isLoading} />}
            {!preventControls && controls()}
            {widgetVisibilityControls}
          </div>
        </header>
      )}
      <div
        ref={handleRef}
        className="panel-body-wrapper"
      >
        <div
          className={
            classNames(
              'panel-body',
              { 'no-padding': noPadding },
              className,
            )}
        >
          {children}
        </div>
        {footer && (
          <div className="panel-footer clearfix">
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}

Widget.defaultProps = {
  controls: () => { },
  widgetVisibilityControls: null,
  footer: null,
  className: undefined,
  noPadding: false,
  title: null,
  isLoading: false,
  handleRef: undefined,
  nonBlockingLoading: false,
};

Widget.propTypes = {
  children: PropTypes.node.isRequired,
  footer: PropTypes.node,
  className: PropTypes.string,
  controls: PropTypes.func,
  widgetVisibilityControls: PropTypes.node,
  noPadding: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  handleRef: PropTypes.func,
  isLoading: PropTypes.bool.isRequired,
  nonBlockingLoading: PropTypes.bool,
};

export default Widget;
